import { AlertsService } from 'app/services/system/alerts/alerts.service';

export function HttpError(
    alertService: AlertsService,
    router,
    error,
    header429: string,
    message429: string,
    header401: string,
    message401: string
) {
    try {
        header429 = header429 == null || header429 == '' ? 'Of margar fyrirspurnir sendar!' : header429;
        message429 =
            message429 == null || message429 == ''
                ? 'Öll misnotkun er skráð og getur leitt til brottvísunar (og/eða bótakröfu).'
                : message429;
        header401 = header401 == null || header401 == '' ? 'Þú þarft að auðkenna þig' : header401;
        message401 =
            message401 == null || message401 == ''
                ? 'Þú átt eftir að innskrá þig eða auðkenningin þín er runnin út. Vinsamlegast innskráðu þig.'
                : message401;

        if (error) {
            if (error.status) {
                if (error.status == 429) {
                    alertService.changealertHeaderMessageFooter(header429, message429, error.error);
                } else if (error.status == 401) {
                } else if (error.status == 404) {
                    return;
                } else if (!error.error) {
                    alertService.changealertHeaderMessageFooter(
                        'Óvænt villa kom upp',
                        'Vinsamlegast reynið að endurræsa síðu og/eða út- og innskrá.',
                        'Hafið samband við kerfisstjórn ef á þarf.'
                    );
                } else {
                    alertService.changealertHeaderMessageFooter(
                        error.error.errorItem.friendlyMessage,
                        error.error.errorItem.message,
                        error.error.errorItem.innerMessage
                    );
                }
            } else {
                alertService.changealertHeaderMessageFooter(
                    'Óvænt villa kom upp',
                    'Vinsamlegast reynið að endurræsa síðu og/eða út- og innskrá.',
                    'Hafið samband við kerfisstjórn ef á þarf.'
                );
            }
        } else {
            alertService.changealertHeaderMessageFooter(
                'Óvænt villa kom upp',
                'Vinsamlegast reynið að endurræsa síðu og/eða út- og innskrá.',
                'Hafið samband við kerfisstjórn ef á þarf.'
            );
        }
    } catch {
        // Occasionally, the API may return an error that doesn’t align with the expected format.
        // To avoid disrupting the user experience on the front end, we simply choose not to display the error if it cannot be translated properly.
        alertService.changealertHeaderMessageFooter('Óvænt villa kom upp', 'Vinsamlegast hafið samband við upplýsingatæknideild LSR.', '');
    }
}
